export default __webpack_public_path__ + "static/soc-9e7813c3ab52e118e467099e6b276bd2.jpg";